import { useTranslation } from 'react-i18next';
import { StyledNewBuildingAddressModal } from "./NewBuildingAddressPopUp.styled";

const NewBuildingAddressPopUp = ({ children, show, onHide }) => {
    const { t } = useTranslation();

    return (
        <StyledNewBuildingAddressModal
            show={show}
            centered
            onHide={onHide}
        >
            <div className="modal-body">
                <h3>{t('buildings.address_pop_up.header')}</h3>
                <h5>{t('buildings.address_pop_up.edit_address')}</h5>
                
                {children}               
            </div>
        </StyledNewBuildingAddressModal>
    );
};

export default NewBuildingAddressPopUp;